import AccessIcon from './AccessIcon'

export default AccessIcon
